if (!Element.prototype.fadeIn) {
    Element.prototype.fadeIn = function () {
        let ms = !isNaN(arguments[0]) ? arguments[0] : 400,
            func =
                typeof arguments[0] === "function" ? arguments[0] : typeof arguments[1] === "function" ? arguments[1] : null;

        this.style.opacity = 0;
        this.style.filter = "alpha(opacity=0)";
        this.style.display = "inline-block";
        this.style.visibility = "visible";

        let $this = this,
            opacity = 0,
            timer = setInterval(function () {
                opacity += 50 / ms;
                if (opacity >= 1) {
                    clearInterval(timer);
                    opacity = 1;

                    if (func) func("done!");
                }
                $this.style.opacity = opacity;
                $this.style.filter = "alpha(opacity=" + opacity * 100 + ")";
            }, 50);
    };
}

if (!Element.prototype.fadeOut) {
    Element.prototype.fadeOut = function () {
        let ms = !isNaN(arguments[0]) ? arguments[0] : 400,
            func =
                typeof arguments[0] === "function"
                    ? arguments[0]
                    : typeof arguments[1] === "function"
                        ? arguments[1]
                        : null;

        let $this = this,
            opacity = 1,
            timer = setInterval(function () {
                opacity -= 50 / ms;
                if (opacity <= 0) {
                    clearInterval(timer);
                    opacity = 0;
                    $this.style.display = "none";
                    $this.style.visibility = "hidden";

                    if (func) func("done!");
                }
                $this.style.opacity = opacity;
                $this.style.filter = "alpha(opacity=" + opacity * 100 + ")";
            }, 50);
    };
}

(function sizeChart() {
    var sizeChartInit = document.querySelectorAll('.sizeChart-label');
    if (sizeChartInit) {
        var sizeChartModel = document.getElementById('sizeChartModel');
        const close = document.querySelectorAll('.sizeChart-wrapper button');
        if (sizeChartModel) {

            sizeChartInit.forEach(function (sizeChart) {
                sizeChart.addEventListener("click", (e) => {
                    e.preventDefault();
                    if (e.currentTarget.parentElement.parentElement.querySelector('#sizeChartModel')) {
                        e.currentTarget.parentElement.parentElement.querySelector('#sizeChartModel').fadeIn(100);
                        console.log('pack')
                        console.log(e.currentTarget.parentElement.parentElement)
                    } else {
                        sizeChartModel.fadeIn(100);
                    }
                    document.querySelector('body').classList.add('sizeChartOpen');
                });
            });
            close.forEach(button => {
                button.addEventListener("click", (e) => {
                    document.querySelector('body').classList.remove('sizeChartOpen');
                    e.currentTarget.parentElement.parentElement.fadeOut(100);
                    console.log(document.querySelector('body').classList)
                    // focusElement.focus();
                    // focusElement='';
                });
            })
        }
    }
})()